import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  DownloadAttackValueLink,
  DownloadAttackValueLinkProps
} from '../../../components/attack-events-grid/cell-content/download-attack-value-link'

export const mapProps = ({
  organizationID,
  eventUuid,
  showTooltip
}: DownloadAttackValueLinkProps) => {
  if (!organizationID) {
    throw new Error('organizationID is required')
  }
  if (!eventUuid) {
    throw new Error('eventUuid is required')
  }

  return {
    organizationID,
    eventUuid,
    showTooltip
  }
}

export const BridgeComponent = (props: DownloadAttackValueLinkProps) => (
  <DownloadAttackValueLink {...mapProps(props)} />
)

export const downloadAttackValueLink = createNgReactBridgeDirective(
  'reactDownloadAttackValueLink',
  [],
  BridgeComponent,
  ['organizationID', 'eventUuid', 'showTooltip']
)
